import { render, staticRenderFns } from "./TabPP3.vue?vue&type=template&id=6d652597&scoped=true&"
import script from "./TabPP3.vue?vue&type=script&lang=js&"
export * from "./TabPP3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d652597",
  null
  
)

export default component.exports